module.exports = __webpack_public_path__ + "static/media/search_prototype_results.994293c9.png";